import React, { useEffect, useState, useCallback } from "react";
import { api } from "../../api/client";
import ConfirmModal from "../../components/ConfirmModal";

function fmtFR(iso) {
  if (!iso) return "";
  return new Date(iso + "T00:00:00").toLocaleDateString("fr-FR",
    { day: "2-digit", month: "2-digit", year: "numeric" });
}
function fmtDateTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("fr-FR",
    { day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit" });
}

const STATUTS = {
  en_attente: { label: "En attente", color: "#f39c12" },
  validee: { label: "Validée", color: "#27ae60" },
  refusee: { label: "Refusée", color: "#e74c3c" },
};

export default function ReservationsSalleAdmin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [acting, setActing] = useState(null); // {resa, action}
  const [comment, setComment] = useState("");
  const [toDelete, setToDelete] = useState(null);
  const [msg, setMsg] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api.get("/admin/salle/reservations");
      setItems(d.items || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const showMsg = (txt) => { setMsg(txt); setTimeout(() => setMsg(""), 3500); };

  const doAction = async () => {
    if (!acting) return;
    try {
      await api.patch(`/admin/salle/reservations/${acting.resa.id}/${acting.action}`,
                       { commentaire: comment });
      const label = acting.action === "valider" ? "validée" : "refusée";
      showMsg(`Réservation #${acting.resa.id} ${label}.`);
      setActing(null); setComment(""); load();
    } catch (e) { alert("Erreur : " + e.message); }
  };

  const confirmDelete = async () => {
    try {
      await api.del(`/admin/salle/reservations/${toDelete.id}`);
      showMsg(`Réservation #${toDelete.id} supprimée.`);
      setToDelete(null); load();
    } catch (e) { alert("Erreur : " + e.message); }
  };

  const filtered = filter === "all" ? items :
                   items.filter((i) => i.statut === filter);

  const counts = {
    all: items.length,
    en_attente: items.filter((i) => i.statut === "en_attente").length,
    validee: items.filter((i) => i.statut === "validee").length,
    refusee: items.filter((i) => i.statut === "refusee").length,
  };

  return (
    <div>
      {msg && <div className="success">{msg}</div>}

      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", marginBottom: "0.8rem" }}>
        <button className={`small ${filter === "all" ? "" : "secondary"}`}
                onClick={() => setFilter("all")}>
          Toutes ({counts.all})
        </button>
        <button className={`small ${filter === "en_attente" ? "" : "secondary"}`}
                onClick={() => setFilter("en_attente")}>
          En attente ({counts.en_attente})
        </button>
        <button className={`small ${filter === "validee" ? "" : "secondary"}`}
                onClick={() => setFilter("validee")}>
          Validées ({counts.validee})
        </button>
        <button className={`small ${filter === "refusee" ? "" : "secondary"}`}
                onClick={() => setFilter("refusee")}>
          Refusées ({counts.refusee})
        </button>
      </div>

      {loading && <p className="muted">Chargement…</p>}
      {!loading && filtered.length === 0 &&
        <p className="muted">Aucune réservation dans cette catégorie.</p>}

      <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
        {filtered.map((r) => (
          <ResaRow key={r.id} resa={r}
                   onValider={() => { setActing({ resa: r, action: "valider" }); setComment(""); }}
                   onRefuser={() => { setActing({ resa: r, action: "refuser" }); setComment(""); }}
                   onDelete={() => setToDelete(r)} />
        ))}
      </div>

      {acting && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 480 }}>
            <div className="modal-header">
              <h3>{acting.action === "valider" ? "Valider" : "Refuser"} la réservation #{acting.resa.id}</h3>
              <button className="modal-close" onClick={() => { setActing(null); setComment(""); }}>×</button>
            </div>
            <div className="modal-body">
              <p>
                <strong>{acting.resa.prenom} {acting.resa.nom}</strong><br/>
                {fmtFR(acting.resa.date_debut)}
                {acting.resa.date_fin !== acting.resa.date_debut && <> → {fmtFR(acting.resa.date_fin)}</>}
              </p>
              <div className="field">
                <label>Commentaire (optionnel)</label>
                <textarea rows={3} value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          placeholder={acting.action === "valider"
                            ? "Ex : Confirmation envoyée par email avec les modalités..."
                            : "Ex : Salle déjà réservée à cette date..."} />
              </div>
              <p className="muted" style={{ fontSize: "0.85em" }}>
                Note : un email automatique n'est pas envoyé pour l'instant.
                Pensez à contacter directement {acting.resa.email} pour informer
                de votre décision.
              </p>
            </div>
            <div className="modal-footer">
              <button className="secondary" onClick={() => { setActing(null); setComment(""); }}>
                Annuler
              </button>
              <button onClick={doAction}
                      style={{ background: acting.action === "valider" ? "#27ae60" : "#e74c3c",
                               color: "#fff" }}>
                {acting.action === "valider" ? "Valider la réservation" : "Refuser la demande"}
              </button>
            </div>
          </div>
        </div>
      )}

      {toDelete && (
        <ConfirmModal
          title="Supprimer cette réservation ?"
          message={`La demande #${toDelete.id} de ${toDelete.prenom} ${toDelete.nom} sera définitivement supprimée.`}
          confirmLabel="Supprimer"
          variant="danger"
          onConfirm={confirmDelete}
          onCancel={() => setToDelete(null)} />
      )}
    </div>
  );
}

function ResaRow({ resa, onValider, onRefuser, onDelete }) {
  const meta = STATUTS[resa.statut] || { label: resa.statut, color: "#666" };
  const nbJours = Math.floor((new Date(resa.date_fin + "T00:00:00") -
                              new Date(resa.date_debut + "T00:00:00")) / 86400000) + 1;
  return (
    <div className="card" style={{ padding: "0.8rem 1rem", borderLeft: `5px solid ${meta.color}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "0.8rem" }}>
        <div style={{ flex: "1 1 320px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", flexWrap: "wrap" }}>
            <strong>#{resa.id} — {resa.prenom} {resa.nom}</strong>
            <span style={{ background: meta.color, color: "#fff",
                          padding: "2px 8px", borderRadius: 4, fontSize: "0.8em",
                          fontWeight: 500 }}>
              {meta.label}
            </span>
            {resa.user_id && (
              <span className="muted" style={{ fontSize: "0.8em" }}>(compte #{resa.user_id})</span>
            )}
          </div>
          <div style={{ marginTop: "0.4rem", fontSize: "0.92rem" }}>
            <strong>📅 {fmtFR(resa.date_debut)}</strong>
            {resa.date_fin !== resa.date_debut && <> → <strong>{fmtFR(resa.date_fin)}</strong></>}
            <span className="muted"> ({nbJours} jour{nbJours > 1 ? "s" : ""})</span>
          </div>
          {resa.type_evenement && (
            <div style={{ marginTop: 2 }}>🎉 {resa.type_evenement}
              {resa.nb_personnes > 0 && <span className="muted"> · {resa.nb_personnes} pers.</span>}
            </div>
          )}
          {resa.commune && (
            <div className="muted" style={{ fontSize: "0.85em", marginTop: 2 }}>
              🏠 Commune : {resa.commune}
            </div>
          )}
          <div className="muted" style={{ fontSize: "0.85em", marginTop: 4 }}>
            ✉ <a href={`mailto:${resa.email}`}>{resa.email}</a>
            {resa.telephone && <> · 📞 {resa.telephone}</>}
          </div>
          {resa.message && (
            <div style={{ marginTop: "0.5rem", padding: "0.4rem 0.6rem",
                          background: "rgba(0,0,0,0.03)", borderRadius: 4,
                          fontSize: "0.9rem", fontStyle: "italic" }}>
              « {resa.message} »
            </div>
          )}
          {resa.commentaire_admin && (
            <div style={{ marginTop: "0.5rem", padding: "0.4rem 0.6rem",
                          background: "rgba(29,79,145,0.06)",
                          borderLeft: `3px solid ${meta.color}`,
                          borderRadius: 4, fontSize: "0.85rem" }}>
              <strong>Commentaire mairie :</strong> {resa.commentaire_admin}
            </div>
          )}
          <div className="muted" style={{ fontSize: "0.78em", marginTop: 4 }}>
            Reçue le {fmtDateTime(resa.created_at)}
            {resa.decided_at && <> · Décision le {fmtDateTime(resa.decided_at)}</>}
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 120 }}>
          {resa.statut === "en_attente" && (
            <>
              <button className="small" onClick={onValider}
                      style={{ background: "#27ae60", color: "#fff", border: "none" }}>
                ✓ Valider
              </button>
              <button className="small" onClick={onRefuser}
                      style={{ background: "#e74c3c", color: "#fff", border: "none" }}>
                ✕ Refuser
              </button>
            </>
          )}
          <button className="small danger" onClick={onDelete}>Supprimer</button>
        </div>
      </div>
    </div>
  );
}
